import { useQuery } from '@tanstack/react-query'
import { getDayforceJob } from 'api/admin/dayforce/getDayforceJob'
import { dayforceKeys } from './keys'

export const useDayforceJobQuery = (agencyId: string, jobId: string) => {
  return useQuery({
    queryKey: dayforceKeys.jobDetail(agencyId, jobId),
    queryFn: () => getDayforceJob(agencyId, jobId),
    enabled: Boolean(agencyId) && Boolean(jobId),
  })
}
